"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translate = exports.Polyglot = exports.I18n = void 0;
var I18n_1 = require("./I18n");
Object.defineProperty(exports, "I18n", { enumerable: true, get: function () { return __importDefault(I18n_1).default; } });
var PolyglotWrapper_1 = require("./PolyglotWrapper");
Object.defineProperty(exports, "Polyglot", { enumerable: true, get: function () { return __importDefault(PolyglotWrapper_1).default; } });
var translateWrapper_1 = require("./translateWrapper");
Object.defineProperty(exports, "translate", { enumerable: true, get: function () { return __importDefault(translateWrapper_1).default; } });
